var steps = [
	{
		type: "System",
		answered: false,
		active: true,
		question: "What type of ostomy system do you prefer to wear or use?",
		options: [
			{
				fullName: "One-piece",
				shortName: "One-piece",
				value: "pc-stoma-one-piece",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "Two-piece",
				shortName: "Two-piece",
				value: "pc-stoma-two-piece",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "No preference",
				shortName: "No pref",
				value: "pc-stoma-no-pref",
				selected: false,
				isMultipleChoice: false
			}
		]
	},
	{
		type: "Output",
		answered: false,
		active: false,
		question: "What best describes the type of output you have coming out of your stoma?",
		options: [
			{
				fullName: "Thick stool",
				shortName: "Thick",
				value: "pc-stoma-output-thick",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "Watery or Mushy",
				shortName: "Watery",
				value: "pc-stoma-output-watery",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "Urine",
				shortName: "Urine",
				value: "pc-stoma-output-urine",
				selected: false,
				isMultipleChoice: false
			}
		]
	},
	{
		type: "Location",
		answered: false,
		active: false,
		question: "Which best describes where your stoma is in relation to your skin?",
		options: [
			{
				fullName: "My stoma sticks out past my skin",
				shortName: "Out",
				value: "pc-stoma-location-out",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "My stoma is even with my skin",
				shortName: "Even",
				value: "pc-stoma-location-even",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "My stoma sinks below my skin",
				shortName: "Below",
				value: "pc-stoma-location-below",
				selected: false,
				isMultipleChoice: false
			}
		]
	},
	{
		type: "Setting",
		answered: false,
		active: false,
		question: " Which best describes the skin around your stoma?",
		options: [
			{
				fullName: "My abdomen is soft and loose",
				shortName: "Soft/Loose",
				value: "pc-stoma-setting-soft-loose",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "My stoma is in a crease or skin fold",
				shortName: "Skin Fold",
				value: "pc-stoma-setting-skin-fold",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "My stoma is near an incision",
				shortName: "Incision",
				value: "pc-stoma-setting-incision",
				selected: false,
				isMultipleChoice: false
			},
			{
				fullName: "None of the above",
				shortName: "None",
				value: "pc-stoma-setting-none",
				selected: false,
				isMultipleChoice: false
			}
		]
	}
];
var stepsPage = {
	numOfNumPreposition: "of",
	getResultsBtnText: "Get my results"
};
var resultsPage = {
	answersList: [
		{
			questionId: 1,
			staticText: "You prefer to wear:",
			options: [
				{
					optionName: "One-piece",
					highlightedText: "a one-piece pouching system."
				},
				{
					optionName: "Two-piece",
					highlightedText: "a one-piece pouching system."
				},
				{
					optionName: "No pref",
					highlightedText: "no preference."
				}
			]
		},
		{
			questionId: 2,
			staticText: "The output from your stoma is",
			options: [
				{
					optionName: "Thick",
					highlightedText: "thick stool"
				},
				{
					optionName: "Watery",
					highlightedText: "watery or mushy."
				},
				{
					optionName: "Urine",
					highlightedText: "urine."
				}
			]
		},
		{
			questionId: 3,
			staticText: "Your stoma",
			options: [
				{
					optionName: "Out",
					highlightedText: "sticks out past your skin."
				},
				{
					optionName: "Below",
					highlightedText: "is even with your skin."
				},
				{
					optionName: "Even",
					highlightedText: "sinks below your skin."
				}
			]
		},
		{
			questionId: 4,
			staticText: "The skin around your stoma is",
			options: [
				{
					optionName: "Soft/Loose",
					highlightedText: "soft and loose."
				},
				{
					optionName: "Skin Fold",
					highlightedText: "in a crease of skin fold."
				},
				{
					optionName: "Incision",
					highlightedText: "near an incision."
				},
				{
					optionName: "None",
					highlightedText: "none of the listed settings."
				}
			]
		},
		{
			questionId: 5,
			staticText: "Show products for",
			options: null
		}
	],
	productSearch: {
		headline: "Your me+ Care Results",
		ctaText: "Sample these products",
		popupId: "some-id"
	},
	recommendations: {
		headline: "Product Recommendations",
		paragraph: "Your answers to these 5 simple questions indicate the following product options may be suitable for you to sample.",
		listHeader: "Your answers to these 5 simple questions indicate the following product options may be suitable for you to sample.<br/><br/>Your me+ care selections indicate:",
		listFooter: "Something not quite right? Contact the me+ support team if you have questions about your results.",
		startOverBtn: {
			text: "Start over"
		},
		contactBtn: {
			text: "Contact us",
			href: "#"
		}
	}
};
var stepsDefaults = {
	steps: steps,
	stepsPage: stepsPage,
	resultsPage: resultsPage
};

export { stepsDefaults as default, resultsPage, steps, stepsPage };
